import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useEffect,useState} from 'react';
import {useParams,useNavigate} from 'react-router-dom';

import AppDashboard from '../AppDashboard';
import ListSessionTypesScreen from '../../components/scheduling/ListSessionTypesScreen';
import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {
  useGetSessionTypesQuery,
  useRemoveSessionTypeMutation,
  useUpdateSessionTypeMutation
} from '../../redux/services/sessionTypeApi';

const handleDelete = ({
  sessionTypesQuery,
  removeSessionType,
  setError
}) => async id => {
  const res = await removeSessionType({id});
  if (res.error) return setError({message: 'Error deleting the session type'});
  setError(null);
  sessionTypesQuery.refetch();
};

const ListSessionTypesPage = props => {
  const [error, setError] = useState(null);
  const {id} = useParams();
  const navigate = useNavigate();
  const providerQuery = useGetCurrentProviderQuery();
  const sessionTypesQuery = useGetSessionTypesQuery(
    {providerId: id},
    {refetch: true, skip: false}
  );
  useEffect(() => {
    sessionTypesQuery.refetch();
  }, []);
  const [removeSessionType] = useRemoveSessionTypeMutation();
  const [updateSessionType] = useUpdateSessionTypeMutation();
  const onDelete = handleDelete({
    sessionTypesQuery,
    removeSessionType,
    setError
  });
  const childProps = {
    ...props,
    loading: !sessionTypesQuery.data || !providerQuery.data,
    provider: get(providerQuery, 'data', null),
    sessionTypes: get(sessionTypesQuery, 'data', null),
    error: (
      get(sessionTypesQuery, 'error')
      || error
    ),
    onCreateSessionType: () => navigate('/providers/settings/session-types/new'),
    onEdit: ({id}) => navigate(`/providers/settings/session-types/edit/${id}`),
    onDelete: ({id}) => onDelete(id),
    onShow: async ({id}) => {
      const response = await updateSessionType({id, body: {hide_from_patients: false}});
      setTimeout(() => sessionTypesQuery.refetch(), 1000);
    },
    onHide: ({id}) => {
      updateSessionType({id, body: {hide_from_patients: true}});
      setTimeout(() => sessionTypesQuery.refetch(), 1000);
    },
  };
  return (
    <AppDashboard
      title='Session Types'
      onBack={() => navigate('/providers/settings')}
      loading={childProps.loading}
      error={childProps.error}>
      <ListSessionTypesScreen {...childProps} />
    </AppDashboard>
  );
};

export default ListSessionTypesPage;
